import CustomizableGeneric from './CustomizableGeneric';

class ItemList extends CustomizableGeneric {
  getTypeName = () => 'ListItem';

  getFields = () => ['url', 'position'];
}

export default ItemList;
